export enum NotificationMessageLevels {
  LEVEL_INFO = 'info',
  LEVEL_ERROR = 'error',
  LEVEL_SUCCESS = 'success',
  LEVEL_WARNING = 'warning',
}

export interface Notification {
  _id: string;
  title: string;
  body: string;
  level: NotificationMessageLevels;
  date: string;
}

export interface Contacts {
  phoneNumber: string;
  discordUsername: string;
}

export interface CompanyDetails {
  department: string;
  position: string;
  firstDay: Date;
  lastDay?: Date;
}

export interface PersonalDetails {
  firstName: string;
  lastName: string;
  fullName: string;
  birthDate: Date;
  image?: File;
}

export interface ProfileConfig {
  enabledDarkTheme: boolean;
  showReviewedEscalations: boolean;
  showReviewedFeedbacks: boolean;
}

export interface Profile {
  _id: string;
  userId: string;
  personalDetails: PersonalDetails;
  companyDetails: CompanyDetails;
  contacts: Contacts;
  profileConfig: ProfileConfig;
  [key: string]: string | PersonalDetails | CompanyDetails | Contacts | ProfileConfig;
}

export interface CreateProfile {
  userId: string;
  personalDetails: Partial<PersonalDetails>;
  contacts: Partial<Contacts>;
}

export interface BaseProfileData {
  profileId: string;
  userId: string;
  firstName: string;
  lastName: string;
  fullName?: string;
}
